import { render, staticRenderFns } from "./feiyi.vue?vue&type=template&id=6a4c3179&scoped=true&"
import script from "./feiyi.vue?vue&type=script&lang=js&"
export * from "./feiyi.vue?vue&type=script&lang=js&"
import style0 from "./feiyi.vue?vue&type=style&index=0&id=6a4c3179&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c3179",
  null
  
)

export default component.exports